import { Html } from "@react-three/drei";

export function DimensionLabel({
  position,
  label,
  visible,
  isMobile,
  isSmall,
  inverse = false,
}) {
  return (
    <Html
      position={position}
      center
      style={{ opacity: visible ? 1 : 0, transition: "opacity 0.25s" }}
    >
      <div
        className={
          isSmall || isMobile
            ? inverse
              ? "modelviewer-label-small-inverse"
              : "modelviewer-label-small"
            : "modelviewer-label"
        }
      >
        {label}
      </div>
    </Html>
  );
}